import React from 'react';
import { Table } from '@devexpress/dx-react-grid-bootstrap4';
import ClickableTableCell from '../shared/ClickableTableCell';
import { format } from '../shared/FormatDetails';
import { CUSTOMER_MORE_THAN_ONE_YEAR_LABEL } from '../../../i18n/keyConstants';
import { useTranslation } from 'react-i18next';


const TableCell = ({ row, column, ...restProps }) => {
    const { t } = useTranslation(['customerTable']);
    const columnName = column.name;

    if (columnName === 'name') {
        return <ClickableTableCell href={`/customer/${row.id}`} showText={row[columnName]} />;
    }

    if (columnName === 'kamEmpName' && row.kamEmpName && row.kampEmpId) {
        return <ClickableTableCell href={`/employee/${row.kampEmpId}/info`} showText={row.kamEmpName} />;
    }

    if (columnName === 'ecoEmpName' && row.ecoEmpName && row.ecoEmpId) {
        return <ClickableTableCell href={`/employee/${row.ecoEmpId}/info`} showText={row.ecoEmpName} />;
    }

    if (columnName === 'latestInvoiceAmount') {
        return (
            <Table.Cell>
                <div className='d-flex align-items-center h-100 justify-content-end'>{format(row.latestInvoiceAmount, 0)}</div>
            </Table.Cell>
        );
    }

    return (
        <Table.Cell {...restProps}>
            <div className='d-flex align-items-center h-100'>{row[columnName] === 'moreThanOneYear' ? t(CUSTOMER_MORE_THAN_ONE_YEAR_LABEL) : row[columnName]}</div>
        </Table.Cell>
    );
};

export default TableCell;
